import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DeclarationService } from 'src/app/modules/dashboard/services/declaration.service';
import { SharingService } from 'src/app/modules/shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-client-selection',
    templateUrl: './client-selection.component.html',
    styleUrls: ['./client-selection.component.css']
})

export class ClientSelectionComponent implements OnInit {
    @Input() clients;
    @Input() displayClientSelection;
    disableSubmit : boolean = false;
    clientsData: [
        {
            PropertyChanges: 0,
            toDelete: false,
            CodePostal: '',
            Email: '',
            LibellePays: '',
            Localite: '',
            NoClient: '',
            NoRue: '',
            Nom: '',
            NumeroBCE: '',
            Prenom: '',
            QualCiv: '',
            RegimeLinguistique: '',
            Rue: ''
        }
    ];
    Name;
    selectedClient: any;
    NumeroBCE: any;
    Rue: any;
    NoRue: any;
    CodePostal: any;
    Localite: any;
    LibellePays: any;
    checkLibellePays: any;
    clientNo: string;
    Year: string;
    Aff_check: string;
    noIntervenant: string;
    isUserAffiliate: boolean;
    LangueClient: string;
    selectedLang: any;
  delayText: any;
    constructor(private translate: TranslateService, private _router: Router, public _declarationService: DeclarationService, public sharingService: SharingService) {
    }
    
  ngOnInit(): void {
    this.delayMessage();
  }
  
  get data(){
    this.selectedLang = this.translate.defaultLang;
    return this.selectedLang;
  }

  delayMessage(){
    
    var currentlang = sessionStorage.getItem("currentlang")
    if(currentlang == "NL"){
      var y = sessionStorage.setItem("presentLang", "Even geduld, we zijn uw gegevens aan het laden");
      this.delayText = y;
    } else {
      var x = sessionStorage.setItem("presentLang", "Veuillez patienter svp, nous chargeons vos données");
      this.delayText = x;
    }
  }

    ngOnChanges(changes: SimpleChanges): void {
        for (let property in changes) {
            if (property === 'clients') {
                this.clientsData = changes[property].currentValue;
                this.NumeroBCE = this.clientsData[0].NumeroBCE;
                this.Rue = this.clientsData[0].Rue;
                this.NoRue = this.clientsData[0].NoRue;
                this.CodePostal = this.clientsData[0].CodePostal;
                this.Localite = this.clientsData[0].Localite;
                this.checkLibellePays = this.clientsData[0].LibellePays;
                var ClientName = this.clientsData[0].QualCiv + " " + this.clientsData[0].Nom + " " +
                    this.clientsData[0].Prenom;
                sessionStorage.setItem('ClientName', ClientName);
                sessionStorage.setItem('ClientNo', this.clientsData[0].NoClient);
                //Take the current year in November and December 
                //in dev, test and acc environments
                if(environment.name == 'Prod') { 
                    sessionStorage.setItem('Year', (new Date().getFullYear() - 1).toString());
                }else{
                    if((new Date().getMonth() + 1) == 11 || (new Date().getMonth() + 1) == 12){
                        sessionStorage.setItem('Year', (new Date().getFullYear()).toString());
                     }else {
                        sessionStorage.setItem('Year', (new Date().getFullYear() - 1).toString());
                     } 
                }   
                sessionStorage.setItem("SelectedClientData", JSON.stringify(this.clientsData[0]));
                if(this.checkLibellePays != null){
                if (this.checkLibellePays.substring(0, 4) !== "Belg" && this.checkLibellePays.substring(0, 4) !== "BELG") {
                    this.LibellePays = this.clientsData[0].LibellePays;
                }
                }
               
                if (this.clientsData.length === 1) {
                    this.disableSubmit = true;
                    this.gotoDashboard();
                }
            }

        }

    }
    SelectedClient(client: any) {
        if (this.clientsData) {
            let obj;
            if(client.split('_')[1] == "" ){
               obj = this.clientsData.filter(m => m.Nom == client.split('_')[0] );
            }else{
               obj = this.clientsData.filter(m => m.Nom == client.split('_')[0] && m.Prenom == client.split('_')[1] );
                 }
            this.selectedClient = obj;
            var selectedClientName = this.selectedClient[0].QualCiv + " " + this.selectedClient[0].Nom + " " + this.selectedClient[0].Prenom;
            sessionStorage.setItem('ClientName', selectedClientName);
            sessionStorage.setItem('ClientNo', this.selectedClient[0].NoClient);
            sessionStorage.setItem("SelectedClientData", JSON.stringify(this.selectedClient[0]));
        }
        //N Enterprise number
        this.NumeroBCE = this.selectedClient[0].NumeroBCE;
        //first adress line
        this.Rue = this.selectedClient[0].Rue;
        this.NoRue = this.selectedClient[0].NoRue;
        //Second adress line
        this.CodePostal = this.selectedClient[0].CodePostal;
        this.Localite = this.selectedClient[0].Localite;
        //Third adress line
        if(this.selectedClient[0].LibellePays != null || this.selectedClient[0].LibellePays != undefined){
        if (this.selectedClient[0].LibellePays.substring(0, 4) !== "Belg" && this.selectedClient[0].LibellePays.substring(0, 4) !== "BELG") {
            this.LibellePays = this.selectedClient[0].LibellePays;
        }}

    }
    gotoDashboard() {
        this.disableSubmit = true;
        this.clientNo = sessionStorage.getItem("ClientNo");
        this.Year = sessionStorage.getItem("Year");
        this.Aff_check = sessionStorage.getItem("AFF_Check");
        if (this.Aff_check != "_AF") {
            this.noIntervenant = sessionStorage.getItem("NoIntervenant");
            this.isUserAffiliate = false;
        } else {
            this.isUserAffiliate = true;
            this.noIntervenant = "0";
        }
        this.LangueClient = "FR";
        this._declarationService.
      // getDeclarationMockupData()
            getFormsDeclarationData(+this.clientNo, +this.Year, +this.noIntervenant, this.LangueClient)
            .subscribe(
                (data) => {
                    sessionStorage.setItem("FormsData", JSON.stringify(data.DeclarationClient.DataXML.xDoc.XMLFile.Declaration));
                    this._router.navigate(['/dashboard']);
                },
                (err) => {
                });
    }
}
